import React from 'react'
import { NavLink } from 'react-router-dom';
import {Container, Divider} from 'semantic-ui-react';
import { Grid } from 'semantic-ui-react';
import {Tab} from 'semantic-ui-react'
import {db} from '../../../firebase';
import Cuentaempresa from './Cuentaempresa';
import Facturacionempresa from './Facturacionempresa';
import Productodisp from './Productodisp';
import useObtenerDatosdeCliente from '../../../hooks/obtenerDatosdeCliente';
var cuenta='Sin contenido'
var facturacion = 'No se muestran datos'
var productos = 'Debe registrar su empresa para contratar servicios'

const panes = [
  {
    menuItem: 'Cuenta',
    render: () => <Tab.Pane  className="item" attached={false}>{cuenta}</Tab.Pane>,
  },
  {
    menuItem: 'Facturación',
    render: () => <Tab.Pane  className="item" attached={false}>{facturacion}</Tab.Pane>,
  },
  {
    menuItem: 'Productos disponibles',
    render: () => <Tab.Pane   className="item"  attached={false}>{productos}</Tab.Pane>,
  },
]

const Serviciositems = (props) => {

  const {userdataClient, data,  loadingDatosdeCliente, errorDatosdeCliente } = useObtenerDatosdeCliente(props.userUid)//(userUid)

  const [dataRates,setDataRates] = React.useState()
  const [paqRates,setPaqRates] = React.useState()
  const [services,setServices] = React.useState()
  
  const [tarifariosData,setTarifariosData] = React.useState()
  const [paymentMethods,setPaymentMethods] = React.useState()
  const [paymentOptions, setPaymentOptions] = React.useState()
  const [plansdata, setPlansData]= React.useState()



    React.useEffect (()=>{
      async  function  getServices () {
        try {
          const services = await db.collection(`${process.env.REACT_APP_COL_AVIABLE_SERV}`)
          .get();
          const data = services.docs.map(doc => ({id: doc.id, ...doc.data()}))
           //console.log(data)
           setServices(data)
        } catch (error) {
          
        }
      }
      getServices()
  
      async  function  getTypeServ () {
        try {
          const services = await db.collection(`${process.env.REACT_APP_COL_AVIABLE_ARTYPE}`)
          .get();
          
          const data = services.docs.map(doc => ({id: doc.id, ...doc.data()}))
           //console.log(data)
            setDataRates(data)
        } catch (error) {
          
        }
      }
      getTypeServ()
  
      async  function  getPaquetes () {
        try {
          const tipospaquetes = await db.collection("typespackage")
          .get();
          
          const data2 = tipospaquetes.docs.map(doc => ({id: doc.id, ...doc.data()}))
          //console.log(data2)
          setPaqRates(data2)
        } catch (error) {
          
        }
      }
      getPaquetes()
      async  function  findTaridarios () {
        try {
          const tarifarios = await db.collection(`${process.env.REACT_APP_COL_RATES}`)
          .get();
          const data3 = tarifarios.docs.map(doc => ({id: doc.id, ...doc.data()}))
          //console.log(data2)
          setTarifariosData(data3)
        } catch (error) {
          
        }
      }
      findTaridarios()
      async  function  findpaymentmethods () {
        try {
          const paymethods = await db.collection(`${process.env.REACT_APP_COL_PAYMETHODS}`)
          .get();
          const data4 = paymethods.docs.map(doc => ({id: doc.id, ...doc.data()}))
            //        console.log(data2)
            setPaymentMethods(data4)
        } catch (error) {
        }
      }
      findpaymentmethods()
  
      async  function  paymentOptions () {
        try {
          const payOptions = await db.collection(`${process.env.REACT_APP_COL_PAYOPTIONS}`)
          .get();
          const data5 = payOptions.docs.map(doc => ({id: doc.id, ...doc.data()}))
            //        console.log(data2)
            setPaymentOptions(data5)
        } catch (error) {
        }
      }
      paymentOptions()
      async  function  findplansdata () {
        try {
          const paymethods = await db.collection(`${process.env.REACT_APP_COL_AVIABLEPLANS}`)
          .get();
          const data4 = paymethods.docs.map(doc => ({id: doc.id, ...doc.data()}))
            //        console.log(data2)
            setPlansData(data4)
        } catch (error) {
        }
      }
      findplansdata()
  
    },[props.userUid]);
 

cuenta = ( <Cuentaempresa props={props} dataRates={dataRates} dataCompany={data} errorDatosdeCliente={errorDatosdeCliente} loadingDatosdeCliente={loadingDatosdeCliente} userBalance={props.userBalance} services={services}></Cuentaempresa>)
facturacion = (<Facturacionempresa props={props} paqRates={paqRates} dataRates={dataRates} companyBilling={props.companyBilling}></Facturacionempresa>)
if(props.userBalance){
  productos = (<Productodisp props={props} paqRates={paqRates} dataRates={dataRates} plansdata={plansdata} companyBilling={props.companyBilling} companyID={props.userBalance} userID={props.userUid}></Productodisp>)
}


 
  return (
   <Tab className="tabular menu" menu={{ secondary: true }} panes={panes}></Tab>
  )
}

export default Serviciositems